import { useEffect, useCallback } from 'react';

import { useSocket } from '@gogame/sockets';

import { EVENT_ENTER_SCREEN } from './constants';

export const useJoinToScreenRoom = ({ name }) => {
  const socket = useSocket();

  const emitEnterScreen = useCallback(() => {
    socket.emit(EVENT_ENTER_SCREEN, name);
  }, [socket, name]);

  //first connect ignored because provider already connected
  //on second connect emit enter screen
  useEffect(() => {
    emitEnterScreen();
    socket.on('connect', emitEnterScreen);
    return () => {
      socket.off('connect', emitEnterScreen);
    };
  }, [socket, emitEnterScreen]);
};
